import {UserService, AuthenticationError} from '@/services/user.service';
import {StorageService, LAST_USED_USERNAME} from "@/services/storage.service";
import router from '@/router';

const state = {
    authenticating: false,
    accessToken: StorageService.getToken(),
    savedUsername: StorageService.get(LAST_USED_USERNAME),
    authenticationError: '',
    authenticationErrorCode: 0,
    user: null,
    filter: null,
    filterLoaded: false,
    isAcceptedApplication: false,
    applications: [],
    favorites: []
};

const getters = {
    loggedIn: (state) => {
        return state.accessToken ? true : false;
    },

    user: (state) => {
        return state.user === null ? {} : state.user;
    },

    filterLoaded: (state) => {
        return state.filterLoaded;
    },

    filter: (state) => {
        return state.filter;
    }
};

const actions = {
    async login({commit, dispatch}, {username, password}) {
        commit('loginRequest');

        try {
            const data = await UserService.login(username, password);

            commit('loginSuccess', {userName: username, accessToken: data.token});

            dispatch('getAcceptedApplications').then(async () => {

                dispatch('user').then(async () => {

                    dispatch('filter').then(async () => {
                        return true;
                    });
                });
            });
        } catch (e) {
            commit('loginError', {errorCode: e.errorCode, errorMessage: e.message});
            throw e;
        }
    },

    async user({commit}) {
        commit('user', null);

        try {
            const result = await UserService.user();
            commit('user', result);
        } catch (e) {
            commit('user', null);
        }
    },

    async filter({commit}) {
        try {
            const result = await UserService.getFilter();
            commit('setFilter', {filter: result, loaded: true});
        } catch (e) {
            commit('setFilter', {filter: null, loaded: false});
        }
    },

    async anonymisedFilter({commit}) {
        try {
            const result = await UserService.getAnonymisedFilter(this.$app.$i18n.locale);
            const anonymisedFilter = JSON.parse(StorageService.get('filterOptions'));
            if (anonymisedFilter) {
                result.filter = anonymisedFilter;
            }
            commit('setFilter', {filter: result, loaded: true});
        } catch (e) {
            commit('setFilter', {filter: null, loaded: false});
        }
    },

    async getAcceptedApplications({commit}) {
        commit('setIsAcceptedApplication', false);

        try {
            const result = await UserService.applications();
            let isMinOneAccepted = false;
            for (const c in result) {
                if (result[c].application.status === 'accepted') {
                    isMinOneAccepted = true;
                    break;
                }
            }

            if (isMinOneAccepted) {
                commit('setIsAcceptedApplication', isMinOneAccepted);
            }
        } catch (e) {
            commit('setIsAcceptedApplication', false);
        }
    },

    applications: async function ({commit}) {
        commit('setApplications', []);

        try {
            const applications = await UserService.applications()

            commit('setApplications', applications);
            return true;
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('setError', {errorCode: e.errorCode, errorMessage: e.message});
            }

            return false
        }
    },

    favorites: async function ({commit}) {
        commit('setFavorites', []);

        try {
            const favorites = await UserService.favorites()

            commit('setFavorites', favorites);
            return true;
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('setError', {errorCode: e.errorCode, errorMessage: e.message});
            }

            return false
        }
    },

    logout({commit}) {
        UserService.logout();
        commit('logoutSuccess');
        router.push({name: 'app'}).catch(error => {
            location.reload();
            console.log(error);
        });
    }
};

const mutations = {
    loginRequest(state) {
        state.authenticating = true;
        state.authenticationError = '';
        state.authenticationErrorCode = '0';
    },

    loginSuccess(state, {userName, accessToken}) {
        StorageService.save(LAST_USED_USERNAME, userName);
        state.accessToken = accessToken;
        state.authenticating = false;
    },

    loginError(state, {errorCode, errorMessage}) {
        state.authenticating = false;
        state.authenticationErrorCode = errorCode;
        state.authenticationError = errorMessage;
    },

    removeLastUsername(state) {
        StorageService.remove(LAST_USED_USERNAME);
        state.savedUsername = '';
    },

    user(state, user) {
        state.user = user;
    },

    setFilter(state, {filter, loaded}) {
        state.filterLoaded = loaded;
        state.filter = filter;
    },

    logoutSuccess(state) {
        state.accessToken = '';
    },

    setIsAcceptedApplication(state, value) {
        state.isAcceptedApplication = value;
    },

    setApplications(state, applications) {
        state.applications = applications;
    },

    setFavorites(state, favorites) {
        state.favorites = favorites;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}